import React from "react";

const Image = ({ image, className = '' }) => {
    return <img className={className} src={image ? `${image}` : '/empty.png'} alt="" />
}


export default Image;
